import { parse } from './parser'
import { type MinidownNode, MinidownNodeType } from './nodes'

/**
 * Strips all Minidown from the source.
 *
 * @param source
 */
export function stripMinidown(source: string | MinidownNode): string {
  return visit(typeof source === 'string' ? parse(source) : source)
}

/**
 * The visitor.
 */
function visit(node: MinidownNode): string {
  switch (node.type) {
    case MinidownNodeType.Text:
    case MinidownNodeType.Break:
      return node.value
    case MinidownNodeType.Emphasis:
    case MinidownNodeType.Strong: {
      return node.children.map(visit).join('')
    }
    case MinidownNodeType.Link:
      return node.children.length > 0 ? visit(node.children[0]) : ''
    case MinidownNodeType.Root:
    case MinidownNodeType.Paragraph: {
      return node.children.map(visit).join('\n\n')
    }
    /* v8 ignore next 2 */
    default:
      return ''
  }
}
